import { i18n } from "@lingui/core";
import WarpElement from "@warp-ds/elements-core";
import { css, html, TemplateResult } from "lit";
import { activateI18n } from "../../utils/i18n.js";

type Step = {
    icon: TemplateResult<1>;
    title: string;
    description: string;
};

class SellSteps extends WarpElement {
    static styles = [
        WarpElement.styles,
        css`
            :host {
                display: block;
            }
            @css-placeholder-7oeG4s;
        `,
    ];

    connectedCallback() {
        activateI18n();
        super.connectedCallback();
    }

    #iconCircle(name: string) {
        return html`
            <div class="h-48 w-48 rounded-full s-bg-subtle flex items-center justify-center">
                <w-icon name="${name}" size="24px" class="block h-24 w-24" locale="nb"></w-icon>
            </div>
        `;
    }

    render() {
        const eyebrow = i18n.t({ id: "sell-steps.eyebrow", message: "How it works" });
        const title = i18n.t({ id: "sell-steps.title", message: "3 simple steps" });

        const steps: Step[] = [
            {
                icon: this.#iconCircle("Car"),
                title: i18n.t({ id: "sell-steps.step-1.title", message: "1. Register the car" }),
                description: i18n.t({
                    id: "sell-steps.step-1.description",
                    message: "Enter the registration number, mileage and answer a few questions.",
                }),
            },
            {
                icon: this.#iconCircle("Warranty"),
                title: i18n.t({ id: "sell-steps.step-2.title", message: "2. Our recommendation" }),
                description: i18n.t({
                    id: "sell-steps.step-2.description",
                    message: "Based on your information, we give you a recommendation on the most suitable way to sell your car.",
                }),
            },
            {
                icon: this.#iconCircle("ProductHighlightListing"),
                title: i18n.t({ id: "sell-steps.step-3.title", message: "3. Choose option" }),
                description: i18n.t({
                    id: "sell-steps.step-3.description",
                    message: "Sell privately, with Smidig bilhandel or with Nettbil.",
                }),
            },
        ];

        return html`
            <section aria-labelledby="sell-steps-title" class="flex flex-col gap-24">
                <div class="flex flex-col gap-4">
                    <p class="text-body s-text-subtle mb-0">${eyebrow}</p>
                    <h2 id="sell-steps-title" class="t2 mb-0">${title}</h2>
                </div>
                <ol class="grid gap-24 md:grid-cols-3 list-none p-0 m-0">
                    ${steps.map(
                        (step) => html`
                            <li class="flex flex-col gap-12">
                                ${step.icon}
                                <h3 class="t4 mb-0">${step.title}</h3>
                                <p class="text-body mb-0">${step.description}</p>
                            </li>
                        `,
                    )}
                </ol>
            </section>
        `;
    }
}

customElements.define("sell-steps", SellSteps as unknown as CustomElementConstructor);
